import { useRouteError } from 'react-router-dom';
/**
 * Error component for when an unexpected error occurs
 * @returns {JSX.Element}
 */
const ErrorComponent = () => {
  const error = useRouteError();
  return (
    <div id="error-page">
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <p>
        <i>{error.statusText || error.message}</i>
      </p>
    </div>
  );
};

export default ErrorComponent;
